const getFirstInvalidFormElement = (
  form: HTMLFormElement
): HTMLElement | void => {
  const focusTarget = Array.from(form.elements).find((element: Element) => {
    return (
      element.getAttribute('data-invalid') === 'true' ||
      element.getAttribute('data-invalid-depricated') === 'true'
    );
  });
  if (focusTarget instanceof HTMLElement) {
    return focusTarget;
  }
};

export const focusFirstInvalidFormElement = (form: HTMLFormElement) => {
  const focusTarget = getFirstInvalidFormElement(form);

  if (focusTarget) {
    focusTarget.focus();

    return true;
  }
  return false;
};
